import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import urlJoin from 'url-join';

export class HttpUrlRewriteInterceptor implements HttpInterceptor {
  constructor(private readonly options: { fromUrl: string; targetUrl: string }) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { fromUrl, targetUrl } = this.options;

    if (req.url?.startsWith(fromUrl)) {
      req = req.clone({
        url: urlJoin(targetUrl, req.url.substr(fromUrl.length)),
      });
    }

    return next.handle(req);
  }
}
